import { Component, OnInit, HostListener } from '@angular/core';
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Tranche } from 'src/app/model/tranche.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ExportService } from 'src/app/features/habilitacao/export.service';
import { JanelaRenunciaResponseDto, Renuncia, TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA } from 'src/app/model/renuncia.model';
import { RenunciaService } from '../renuncia.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataSistemaService } from "src/app/shared/services/data-sistema.service";
import { JanelaSolicitacaoRenunciaService } from '../janela-solicitacao-renuncia.service';

const NUMERO_TRANCHE_PADRAO: number = 1;

@Component({
    selector: 'app-limite-exposicao-pesquisa',
    templateUrl: 'renuncia-pesquisa.component.html',
    styleUrls: ['./renuncia-pesquisa.component.scss'],
    standalone: false
})
export class RenunciaPesquisaComponent implements OnInit {

  public cnpjUsuario: string;
  public cnpjAgentePesquisa: string;
  public agenteFinanceiro: AgenteFinanceiro;
  public agentesFinanceiros: AgenteFinanceiro[] = [];
  public podeEscolherAgente: boolean;
  public refresh: number = 0;
  public limpar: number = 0;

  public agenteFinanceiroPesquisa: AgenteFinanceiro;

  public renuncia: Renuncia;
  renuncias: Renuncia[] = [];
  public janelaRenuncia: JanelaRenunciaResponseDto;
  public dataLimitePesquisa: string;
  podeCadastrarRenuncia: boolean = false;
  private readonly destroy$ = new Subject();
  public tranches: Tranche[];
  public pesquisaForm: UntypedFormGroup;
  pesquisado = false;
  iniciado: boolean = false;
  carregandoJanela: boolean = true;
  ehAgenteFinanceiro: boolean = false;
  private dataCorrente: Date;
  periodoDeRenunciaEncerrado: boolean = true;

  constructor(private permissaoService: PermissaoService,
    private alertsService: BnAlertsService,
    private renunciaService: RenunciaService,
    private bnUsuarioService: BnUsuarioService,
    private bnLoadingService: BnLoadingService,
    private agenteFinanceiroService: AgenteFinanceiroService,
    private exportService: ExportService,
    private trancheService: TrancheService,
    private formBuilder: UntypedFormBuilder,
    dataSistemService: DataSistemaService,
    private janelaSolicitacaoRenunciaService: JanelaSolicitacaoRenunciaService) {

    dataSistemService.getDataCorrente().subscribe(data => this.dataCorrente = data);

    this.pesquisaForm = this.formBuilder.group({
      tranche: [null, [Validators.required]],
      agenteFinanceiro: null,
    });
    this.pesquisaForm.get('tranche').disable();
    this.pesquisaForm.get('agenteFinanceiro').disable();
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar()
  }

  public ngOnInit() {
    this.carregar();
  }

  async carregar() {
    this.bnLoadingService.bloqueiaTela();
    try {
      await Promise.all([
        this.carregarListaAgentesFinanceiros(),
        this.getJanelaRenuncia()
      ]);

      this.tranches = await this.trancheService.getTranches().toPromise();
      this.selecionaTranche();

      this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
        this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
        this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_ENVIO]
      });

      if(this.ehAgenteFinanceiro) {
        this.buscar();
      }
    } catch (err) {
      console.log('erro ao carregar dados', err);
      this.alertsService.alertaErro("Erro", "Erro ao carregar os dados");
    } finally {
      this.bnLoadingService.liberaTela();
      this.iniciado = true;
    }
  }

  async carregarListaAgentesFinanceiros() {
    const agents = await this.agenteFinanceiroService.getAgentesFinanceiros().toPromise();
    this.agentesFinanceiros = agents ? agents.sort((a, b) =>
      a?.nome ? a.nome.localeCompare(b.nome) : 0) : null;
    this.bnUsuarioService.usuario$
      .pipe(takeUntil(this.destroy$))
      .subscribe(usuario => {
      if (usuario && usuario.cnpj) {
        this.cnpjUsuario = usuario.cnpj;
        this.setAgenteFinancieroLogado();
      } else if (!(usuario?.cnpj)) {
        this.pesquisaForm.get('agenteFinanceiro').enable();
      }
    });
  }

  async getJanelaRenuncia() {
    this.carregandoJanela = true;
    try {
      this.janelaRenuncia = await this.renunciaService.getJanelaAtiva().toPromise();
      if (!this.janelaRenuncia) {
        const janelas = await this.janelaSolicitacaoRenunciaService.obterJanelasPorTipo(TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA).toPromise();

        if (janelas.length > 1) {
          this.janelaRenuncia = janelas[janelas.length - 1];
        } else if (janelas.length == 1) {
          this.janelaRenuncia = janelas[0];
        }
      }

      if (this.janelaRenuncia) {
        const dataCorrenteSemHora = moment(this.dataCorrente);

        const dataCorrente = moment();
        dataCorrente.set('days', dataCorrenteSemHora.get('days'));
        dataCorrente.set('months', dataCorrenteSemHora.get('months'));
        dataCorrente.set('years', dataCorrenteSemHora.get('years'));

        let periodoNaoEncerrado = dataCorrente.isAfter(this.janelaRenuncia.dataInicioVigencia) && dataCorrente.isBefore(this.janelaRenuncia.dataFimVigencia);
        this.podeCadastrarRenuncia = periodoNaoEncerrado;
        this.periodoDeRenunciaEncerrado = !periodoNaoEncerrado
      }
    } catch (err) {
      console.log('erro ao carregar janela', err);
    } finally {
      this.carregandoJanela = false;
    }
  }

  atribuiAgenteFinanceiro(cnpj) {
    if (!cnpj) {
      this.agenteFinanceiro = undefined;
    } else if (cnpj == -1 || cnpj == null) { // Todos
      this.agenteFinanceiro = new AgenteFinanceiro();
      this.agenteFinanceiro.id = -1;
    } else {
      for (const agente of this.agentesFinanceiros) {
        if (agente.cnpj === cnpj) {
          this.agenteFinanceiro = agente;
        }
      }
    }
  }

  async buscar(id?: number) {
    this.pesquisado = false;
    this.bnLoadingService.bloqueiaTela();

    try {
      this.atribuiAgenteFinanceiro(this.pesquisaForm.value.agenteFinanceiro);

      const response = await this.renunciaService.getRenuncias(this.agenteFinanceiro?.id).toPromise();
      this.renuncias = response ? response : null;
      this.pesquisado = true;

      this.agenteFinanceiroPesquisa = this.agenteFinanceiro;
      this.refresh++;
    } finally {
      this.bnLoadingService.liberaTela();
    }
  }

  exportarLista() {
    this.bnLoadingService.bloqueiaTela();
    this.renunciaService.getRenunciasDetalhe(this.agenteFinanceiro?.id).subscribe((response) => {
      this.exportService.exportarListaRenuncia(response);
    })
    this.bnLoadingService.liberaTela();
  }

  limparPesquisa() {
    this.cnpjAgentePesquisa = undefined;
    this.agenteFinanceiro = undefined;
    if (!this.cnpjUsuario) {
      this.pesquisaForm.get('agenteFinanceiro').setValue(null);
    }
    this.limpar++;
    this.renuncias = [];
    this.pesquisado = false;
  }

  setAgenteFinancieroLogado() {
    if (this.cnpjUsuario) {
      const agenteFinanceiroSelect = this.agentesFinanceiros.find(agente => agente.cnpj === this.cnpjUsuario);
      this.pesquisaForm.get('agenteFinanceiro').setValue(agenteFinanceiroSelect?.cnpj);
      this.pesquisaForm.get('agenteFinanceiro').disable();
    }
  }

  selecionaTranche() {
    if (this.tranches) {
      const trancheSelecionada = this.tranches.find(tranche => tranche.numeroTranche == NUMERO_TRANCHE_PADRAO);
      this.pesquisaForm.get('tranche').setValue(trancheSelecionada?.id);
      this.pesquisaForm.get('tranche').disable();
    }
  }
}
